import React, { Component } from "react";
import Chart from "./components/chart";
import { withRouter } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";
import styled from "styled-components";
import { Api } from "../utils/api";
import { DashboardFilterForm } from "./forms/dashboard-filter.form";

class dashboardView extends Component {
  state = {
    showLoading: true,
    analyticsTypes: {
      ADMISSIONS: "Nº Admissões",
      SUBSCRIPTIONS: "Nº Subscrições",
      PLANS_DISTRIBUTION: "Planos ativos",
      PLANS_PAYED_DISTRIBUTION: "Planos pagos (ativos)",
    },
    analyticsTypesLoading: {
      ADMISSIONS: true,
      SUBSCRIPTIONS: true,
      PLANS_DISTRIBUTION: true,
      PLANS_PAYED_DISTRIBUTION: true,
    },
    analyticsChartsData: {},
    analyticsDailyChartsData: {},
    socialWorker: true,
    user: null,
  };

  constructor() {
    super();
    this.api = new Api();
    this.user = localStorage.getItem("email");
    this.user_id = localStorage.getItem("id");
    this.requestAnalytics = this.requestAnalytics.bind(this);
  }

  componentDidMount() {
    this.requestAnalytics(this.user);
    this.api
      .get(`/admins/${this.user_id}`, {}, true)
      .then(({ data: admin }) => {
        this.setState({ socialWorker: admin.id_group === 5 });
      });
  }

  requestAnalytics(user) {
    if (!user) user = this.user;
    this.setState({ user });
    this.requestAllAnalytics(user);
    this.requestDailyAnalytics(user);
  }

  requestAllAnalytics(user) {
    this.setState({ showLoading: true });
    let promises = [];
    const analyticsTypes = Object.keys(this.state.analyticsTypes);
    for (let i = 0; i < analyticsTypes.length; i++) {
      promises.push(
        this.api.post("/analytics", {
          type: analyticsTypes[i],
          filter: "one_month",
          user,
        })
      );
    }
    Promise.all(promises).then((returns) => {
      let analyticsChartsData = this.state.analyticsChartsData;
      for (let i = 0; i < analyticsTypes.length; i++) {
        const analyticData = returns[i].data;
        if (!analyticData) continue;
        if (analyticsTypes[i] !== "PLANS_DISTRIBUTION")
          analyticsChartsData[analyticsTypes[i]] =
            this.createAnalyticChartsDataEntry(analyticsTypes[i], analyticData);
        else this.state.analyticsChartsData[analyticsTypes[i]] = analyticData;
        //
        let analyticsTypesLoading = this.state.analyticsTypesLoading;
        analyticsTypesLoading[analyticsTypes[i]] = false;
        this.setState({ analyticsTypesLoading });
      }
      this.setState({ analyticsChartsData });
      this.setState({ showLoading: false });
    });
  }

  requestDailyAnalytics(user) {
    this.setState({ showLoading: true });
    let promises = [];
    const analyticsTypes = [
      "DAILY_ADMISSIONS",
      "DAILY_ADMISSIONS_ACCEPTED",
      "DAILY_ADMISSIONS_PENDING",
      "DAILY_ADMISSIONS_ONGOING",
      "DAILY_ADMISSIONS_TOTAL",
      "DAILY_ADMISSIONS_CANCELED",
      "DAILY_ADMISSIONS_STANDBY",
      "DAILY_SUBSCRIPTIONS",
      "DAILY_FORWARDING_TOTAL",
      "DAILY_FORWARDING_ACCEPTED",
    ];
    for (let i = 0; i < analyticsTypes.length; i++) {
      promises.push(
        this.api.post("/analytics", {
          type: analyticsTypes[i],
          filter: "one_day",
          user,
        })
      );
    }
    Promise.all(promises).then((returns) => {
      let analyticsDailyChartsData = this.state.analyticsDailyChartsData;
      for (let i = 0; i < analyticsTypes.length; i++) {
        if (!returns[i].data)
          returns[i].data = { date: new Date(), count: 0, sum: 0 };
        const analyticData = returns[i].data;
        if (!analyticData) continue;
        //console.log(analyticData)
        analyticsDailyChartsData[analyticsTypes[i]] = analyticData;
      }
      this.setState({ analyticsDailyChartsData });
      this.setState({ showLoading: false });
    });
  }

  filterChart = (analyticType, periodType) => {
    let analyticsLoading = this.state.analyticsTypesLoading;
    analyticsLoading[analyticType] = true;
    this.setState({ analyticsTypesLoading: analyticsLoading });
    this.api
      .post("/analytics", {
        type: analyticType,
        filter: periodType,
        user: this.user,
      })
      .then((response) => {
        const analyticData = response.data;
        let analyticsChartsData = this.state.analyticsChartsData;
        analyticsChartsData[analyticType] = this.createAnalyticChartsDataEntry(
          analyticType,
          analyticData
        );
        let analyticsTypesLoading = this.state.analyticsTypesLoading;
        analyticsTypesLoading[analyticType] = false;
        this.setState({
          analyticsTypesLoading,
          analyticsChartsData,
        });
      });
  };

  createAnalyticChartsDataEntry(analyticType, analyticData) {
    return {
      title: this.state.analyticsTypes[analyticType],
      data: analyticData.map((entry) => {
        return {
          name: entry.description,
          type: analyticType === "SUBSCRIPTIONS" ? "line" : "column",
          data: entry.data.map((e) => {
            return e.count;
          }),
        };
      }),
      // TODO join all timelines and then distinct
      timeline: analyticData[0].data.map((entry) => {
        return entry.date_at_ym;
      }),
    };
  }

  render() {
    const { showLoading } = this.state;
    return showLoading ? (
      <>
        <LoadingContainer hidden={!this.state.showLoading}>
          <CircularProgress color="primary" />
        </LoadingContainer>
      </>
    ) : (
      <>
        <div>
          <p>
            <strong>Indicadores diários</strong>
          </p>
        </div>
        <br />
        <div class="row">
          <div class="col">
            {this.state.analyticsDailyChartsData["DAILY_SUBSCRIPTIONS"] &&
              !this.state.socialWorker && (
                <div>
                  <span>Subscrições (a cobrança): </span>
                  {this.state.analyticsDailyChartsData["DAILY_SUBSCRIPTIONS"]
                    .count +
                    " (€" +
                    this.state.analyticsDailyChartsData["DAILY_SUBSCRIPTIONS"]
                      .sum +
                    ")"}
                </div>
              )}
            {this.state.analyticsDailyChartsData["DAILY_ADMISSIONS"] && (
              <div>
                <span>
                  {!this.state.socialWorker
                    ? "Pedidos (a cobrança)"
                    : "Meus Pedidos admitidos"}
                  :{" "}
                </span>
                {this.state.analyticsDailyChartsData["DAILY_ADMISSIONS"].count +
                  " (€" +
                  this.state.analyticsDailyChartsData["DAILY_ADMISSIONS"].sum +
                  ")"}
              </div>
            )}
            {this.state.analyticsDailyChartsData[
              "DAILY_ADMISSIONS_ACCEPTED"
            ] && (
              <div>
                <span>
                  {!this.state.socialWorker
                    ? "Pedidos aceites (pelo menos 1 aceitação)"
                    : "Meus Pedidos aceites (pelo menos 1 aceitação)"}
                  :{" "}
                </span>
                {
                  this.state.analyticsDailyChartsData[
                    "DAILY_ADMISSIONS_ACCEPTED"
                  ].count
                }
              </div>
            )}
            {this.state.analyticsDailyChartsData[
              "DAILY_ADMISSIONS_ONGOING"
            ] && (
              <div>
                <span>
                  {!this.state.socialWorker
                    ? "Pedidos em curso (pelo menos 1 encam.; sem aceitações)"
                    : "Meus Pedidos em curso (pelo menos 1 encaminhamento)"}
                  :{" "}
                </span>
                {
                  this.state.analyticsDailyChartsData[
                    "DAILY_ADMISSIONS_ONGOING"
                  ].count
                }
              </div>
            )}
            {this.state.analyticsDailyChartsData[
              "DAILY_ADMISSIONS_PENDING"
            ] && (
              <div>
                <span>
                  {!this.state.socialWorker
                    ? "Pedidos pendentes (sem encaminhamentos)"
                    : "Meus Pedidos pendentes (sem encaminhamentos)"}
                  :{" "}
                </span>
                {
                  this.state.analyticsDailyChartsData[
                    "DAILY_ADMISSIONS_PENDING"
                  ].count
                }
              </div>
            )}
            {this.state.analyticsDailyChartsData[
              "DAILY_ADMISSIONS_STANDBY"
            ] && (
              <div>
                <span>
                  {!this.state.socialWorker
                    ? "Pedidos em standby"
                    : "Meus Pedidos em standby"}
                  :{" "}
                </span>
                {
                  this.state.analyticsDailyChartsData[
                    "DAILY_ADMISSIONS_STANDBY"
                  ].count
                }
              </div>
            )}
            {this.state.analyticsDailyChartsData[
              "DAILY_ADMISSIONS_CANCELED"
            ] && (
              <div>
                <span>
                  {!this.state.socialWorker
                    ? "Pedidos cancelados"
                    : "Meus Pedidos cancelados"}
                  :{" "}
                </span>
                {
                  this.state.analyticsDailyChartsData[
                    "DAILY_ADMISSIONS_CANCELED"
                  ].count
                }
              </div>
            )}
            {this.state.analyticsDailyChartsData["DAILY_ADMISSIONS_TOTAL"] && (
              <div>
                <span>
                  {!this.state.socialWorker
                    ? "Pedidos (total)"
                    : "Meus Pedidos (total)"}
                  :{" "}
                </span>
                {
                  this.state.analyticsDailyChartsData["DAILY_ADMISSIONS_TOTAL"]
                    .count
                }
              </div>
            )}
            <br />
            {this.state.analyticsDailyChartsData["DAILY_FORWARDING_TOTAL"] && (
              <div>
                <span>
                  {!this.state.socialWorker
                    ? "Encaminhamentos (total)"
                    : "Meus Encaminhamentos (total)"}
                  :{" "}
                </span>
                {
                  this.state.analyticsDailyChartsData["DAILY_FORWARDING_TOTAL"]
                    .count
                }
              </div>
            )}
            {this.state.analyticsDailyChartsData[
              "DAILY_FORWARDING_ACCEPTED"
            ] && (
              <div>
                <span>
                  {!this.state.socialWorker
                    ? "Encaminhamentos aceites"
                    : "Meus Encaminhamentos aceites"}
                  :{" "}
                </span>
                {
                  this.state.analyticsDailyChartsData[
                    "DAILY_FORWARDING_ACCEPTED"
                  ].count
                }
              </div>
            )}
          </div>
          {!this.state.socialWorker && (
            <div class="col">
              <div style={{ maxWidth: "500px" }}>
                <DashboardFilterForm
                  admin_id={this.state.user}
                  onChange={this.requestAnalytics}
                />
              </div>
            </div>
          )}
        </div>

        <br />
        <ChartContainer>
          {this.state.analyticsChartsData.SUBSCRIPTIONS &&
            !this.state.socialWorker && (
              <Chart
                title={this.state.analyticsChartsData.SUBSCRIPTIONS.title}
                analytic={Object.keys(this.state.analyticsTypes)[1]}
                showLoading={this.state.analyticsTypesLoading.SUBSCRIPTIONS}
                data={this.state.analyticsChartsData.SUBSCRIPTIONS.data}
                timeline={this.state.analyticsChartsData.SUBSCRIPTIONS.timeline}
                type="line"
                height={400}
                showControls={true}
                filterChart={this.filterChart}
              />
            )}
          {this.state.analyticsChartsData.ADMISSIONS && (
            <Chart
              title={this.state.analyticsChartsData.ADMISSIONS.title}
              analytic={Object.keys(this.state.analyticsTypes)[0]}
              showLoading={this.state.analyticsTypesLoading.ADMISSIONS}
              data={this.state.analyticsChartsData.ADMISSIONS.data}
              timeline={this.state.analyticsChartsData.ADMISSIONS.timeline}
              type="line"
              height={400}
              showControls={true}
              filterChart={this.filterChart}
            />
          )}
          {false && (
            <Chart
              title="Admissões"
              data={this.state.lineChart1Series}
              timeline={this.state.lineChart1Timeline}
              type="line"
              height={400}
              showControls={true}
              filterChart={this.filterChart}
            />
          )}
          {!this.state.socialWorker &&
            this.state.analyticsChartsData.PLANS_DISTRIBUTION && (
              <Chart
                title="Planos ativos"
                data={this.state.analyticsChartsData.PLANS_DISTRIBUTION}
                type="pie"
                height={250}
              />
            )}
          {!this.state.socialWorker &&
            this.state.analyticsChartsData.PLANS_PAYED_DISTRIBUTION && (
              <Chart
                title={
                  this.state.analyticsChartsData.PLANS_PAYED_DISTRIBUTION.title
                }
                analytic={Object.keys(this.state.analyticsTypes)[0]}
                showLoading={
                  this.state.analyticsTypesLoading.PLANS_PAYED_DISTRIBUTION
                }
                data={
                  this.state.analyticsChartsData.PLANS_PAYED_DISTRIBUTION.data
                }
                timeline={
                  this.state.analyticsChartsData.PLANS_PAYED_DISTRIBUTION
                    .timeline
                }
                type="line"
                height={400}
              />
            )}
        </ChartContainer>
      </>
    );
  }
}
export default withRouter(dashboardView);

//CSS
const ChartContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  > div {
    position: relative;
    padding: 20px;
    border-radius: 10px;
    background-color: #f8f8f8;
    margin: 1%;
    width: 48%;
  }
`;
const LoadingContainer = styled.section`
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: white;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
`;
